import {DefaultSettings, settings} from '../../../settings/settings-util';
import reducer from './reducers';
import GetHistoryResponseHandler from './response-handler-history';
import { sendRequest } from '../../lib-alme-request/src/lib-alme-request';
import {AlmeState} from "../../../wireup/AlmeState";
import {Reducer, Store} from "redux";
import {AlmeUIMessage} from '../../../types/response';

type Disruptor = { shouldDisrupt: (passedSettings: typeof settings, store: Store<AlmeState> | null) => boolean };


export default class InitializeGetHistory
{

    _settings: typeof settings;
    _disruptors: Disruptor[];
    _store: Store<AlmeState> | null = null;


    //#region Public Interface

    constructor(passedSettings?: DefaultSettings, initActionDisruptors: Disruptor[] = [])
    {
        this._settings = passedSettings ?? settings;
        this._disruptors = initActionDisruptors;
    }

    static getDefaultSettings(): typeof settings
    {
        return settings;
    }

    getReducer(): Reducer<AlmeState["History"]>
    {
        return reducer;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
    }

    getPromise(): Promise<void | AlmeUIMessage> {
        if (this.shouldAct()) {
            const input = {
                messageType: this._settings.messageConstants.getHistoryRequest,
                messageLimit: this._settings.History.messageLimit,
                includeRevertedEntries: this._settings.History.includeRevertedEntries,
            };

            return sendRequest(input);
        }

        return Promise.resolve();
    }

    getResponseHandler(): GetHistoryResponseHandler
    {
        return new GetHistoryResponseHandler(this._settings);
    }

    //#endregion



    //#region Helper Methods

    shouldAct(): boolean
    {
        return !this._disruptors.some(disruptor => {
            try
            {
                return disruptor.shouldDisrupt(this._settings, this._store);
            }
            catch (e)
            {
                console.log('InitGetHistory disruptor threw exception.', e);

                return false;
            }
        });
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/initialization-gethistory/src/initialization-gethistory.ts